import React, { useEffect } from 'react'
import { useAppSelector } from '../../../../store/hooks/StoreHooks';
import useCollapseFacade from '../../../../facade/collapse.Facade';
import Accordion from '../../../common/accordion';
import EquipmentTableAddChargePump from '../../../common/equipment-table-charge-pump';
import LABELS from '../../../../constants/labels/schematics.labels';
import useSchematicFacade from '../../../../facade/calculation/calculation-output/schematic.facade';
import useCalculationFacade from '../../../../facade/calculation/calculation.facade';


const AccessoriesAboveESP: React.FC = () => {
    const { accessoriesAboveEspCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { EquipmentsAboveESP, ESPEquipmentsForAbove } = useAppSelector(state => state?.schematic);

    const { updateAccessoriesAboveEspCollapse } = useCollapseFacade();
    const { updateESPEquipmentsForAboveESP } = useSchematicFacade();
    const { updateSchematicEquipmentData } = useCalculationFacade();

    const handleCollapseChange = (key: boolean) => {
        updateAccessoriesAboveEspCollapse(key);
    };

    const handleEquipmentChange = (rows: any[], rowIndex: number) => {
        let ESPEquipmentsForAboveESP = [...ESPEquipmentsForAbove];
        ESPEquipmentsForAboveESP[rowIndex] = rows;
        if (ESPEquipmentsForAboveESP?.length === 4)
            updateESPEquipmentsForAboveESP([...ESPEquipmentsForAboveESP]);
        else
            updateESPEquipmentsForAboveESP([...ESPEquipmentsForAboveESP, {}]);
        updateSchematicEquipmentData();
    }

    useEffect(() => {
        if (
            ESPEquipmentsForAbove.length < 4 &&
            !ESPEquipmentsForAbove.some(
                (item: any) => Object.keys(item).length === 0
            )
        ) {
            updateESPEquipmentsForAboveESP([...ESPEquipmentsForAbove, {}]);
        }
    }, [ESPEquipmentsForAbove]);

    const handleClear = (id: String, index: number) => {
        const ESPEquipmentsForAboveESP = [...ESPEquipmentsForAbove];
        const filtered = ESPEquipmentsForAboveESP.filter((x, i) => i < index);
        updateESPEquipmentsForAboveESP([...filtered, {}]);

        updateSchematicEquipmentData();
    }

    return (
        <Accordion
            title={LABELS?.accessoriesAboveESP}
            isOpen={accessoriesAboveEspCollapse}
            onToggle={() => handleCollapseChange(!accessoriesAboveEspCollapse)}
            content={
                <div className='flex flex-col p-4'>
                    <EquipmentTableAddChargePump
                        options={EquipmentsAboveESP}
                        equipments={ESPEquipmentsForAbove?.length > 0 ? ESPEquipmentsForAbove : [{}]}
                        rowLength={EquipmentsAboveESP?.length === 1 ? 1 : 4}
                        onChange={handleEquipmentChange}
                        onClear={(id: String, index: number) => handleClear(id, index)}
                    />
                </div>
            }
        />
    );
}

export default AccessoriesAboveESP